import { CToast, CToastBody, CToastClose } from "@coreui/react";
import jwtDecode from "jwt-decode";
import moment from "moment/moment";
import React from 'react'
import { specialFares } from "./constants";

const userRole = () => {
    const user = jwtDecode(getToken())
    return user;
}
const onlyDateFormate = (date) => {
    return moment(date).format("DD/MM/YYYY")
}

const dateFormateForDeepLinkFM = (date) => {
    return moment(date).format("MM/DD/YYYY")
}

const getFormattedDateTime = (date) => {
    return moment.utc(date).format("MMM DD, yyyy | hh:mm A")
};

const getFormattedDateTime2 = (date) => {
    return moment(date).format("MMM DD, yyyy | hh:mm A")
};
const getFormattedDateTime1 = (date) => {
    return moment.utc(date).format("MMM DD, yyyy  hh:mm A")
};

const getFormattedDateTime3 = (date) => {
    return moment.utc(date).format("DD MMM yyyy | hh:mm A")
};

const getDayDate = (date) => {
    return moment.utc(date).format("MMM DD yyyy")
}
const getUtcTime = (date) => {
    return moment.utc(date).format("hh:mm A")
}

const getTime = (date) => {
    return moment(date).format("hh:mm A")
}

const getTime2 = (date) => {
    return moment(date).format("hh:mm:ss A")
}

const getTime3 = (time) => {
    if (time?.indexOf(":") == -1)
        return time.substr(0, 2) + ":" + time.substr(2, 2);
    return time?.substr(0, 5);
}

const getFormattedDate2 = (date) => {
    return moment(date).format("MMM DD, YYYY")
}

const getFormattedDate3 = (date) => {
    return moment(date).format("ddd, MMMM DD, yyyy")
}
const getFormattedDate4 = (date) => {
    return moment(date).format("ddd, MMM DD")
}

const getFormattedDate5 = (date) => {
    return moment(date).format("DD-MM-yyy")
}

const getFormattedDate6 = (date) => {
    return moment(date).format("ddd, DD MMMM yyyy")
}

const getFormattedDate7 = (date) => {
    return moment(date).format("DD MMM YYYY")
}

const getFormattedDate12 = (date) => {
    return moment(date, "DD-MM-YYYY").format("DD MMM YYYY");
};

const toLocalISOString = (date) => {
  if (!date) return null;
  const d = new Date(date);
  const offset = d.getTimezoneOffset() * 60000; 
  return new Date(d - offset).toISOString().slice(0, -1); 
};


const convertSecondsToHMS = (seconds) => {
    const hh = Math.floor(seconds / 3600);
    const mm = Math.floor((seconds % 3600) / 60);
    const ss = Math.floor(seconds % 60);
    return hh.toString().padStart(2, '0') + ':' + mm.toString().padStart(2, '0') + ':' + ss.toString().padStart(2, '0');
};


const getDiffFromMinutes = (minutes) => {
    let difference = moment.duration(parseInt(minutes), 'minutes');
    let allHours = (difference.hours() + (24 * difference.days()));
    return (allHours > 9 ? (allHours + "h") : "0" + allHours + "h")
        + " " + (difference.minutes() > 9 ? difference.minutes() + "m" : "0" + difference.minutes() + "m");
}

const countTotalDuration = (value) => {
    const b = value?.split("")
    return (b[0] + b[1] + "h" + " " + b[2] + b[3] + "m")
}

const getFormatedDateOfBirth = (date) => {
    return moment(date).format("MMMM, D YYYY")
}

const getFormattedTime = (time) => {
    return moment(time, "hh:mm").format("hh:mm A");
}

const getDisplayClass = (cls) => {

    if (cls === "Y" || cls === "W")
        return "Premium Economy";
    else if (cls === "F")
        return "First";
    else if (cls === "C")
        return "Business";
    else
        return "Economy";
};

const getToken = () => {
    const token = localStorage.getItem("auth");
    return token;
};

const getFormattedContactNo = (mobile) => {
    return 'XXX-XXX-' + mobile.substr(6)
};

const maskCardNumber = (cardNumber) => {
    const numToString = cardNumber?.toString();
    const lastFourDigit = numToString?.slice(-4)
    return lastFourDigit?.padStart(16, "X");
};

const creditCardFormat = (value) => {
    const v = value
        .replace(/\s+/g, "")
        .replace(/[^0-9]/gi, "")
        .substr(0, 16);
    const parts = [];

    for (let i = 0; i < v.length; i += 4) {
        parts.push(v.substr(i, 4));
    }

    return parts.length > 1 ? parts.join("-") : value;
}

//To convert first letter capital
const capitalizeFirstLetter = (str) => {
    const firstLetter = (str?.charAt(0))?.toUpperCase();
    const remainingLetter = str?.slice(1);
    return (firstLetter + remainingLetter);
}

// payment status on behalf of payment status id

const getCurrentPaymentStatus = (status) => {
    switch (status) {
        case 1:
            return "CCV PENDING"
        case 2:
            return "CCV-DECLINE"
        case 3:
            return "CANCELLED"
        case 4:
            return "TICKET-DONE"
        case 5:
            return "VOID"
        case 6:
            return "VOID AND FRESH"
        case 7:
            return "FUTURE-CREDIT"
        case 8:
            return "REFUND"
        case 9:
            return "CCD DECLINE"
        case 10:
            return "CCV-DONE"
        case 11:
            return "APR-Unticketed"
        default:
            return
    }
};


// web check in status common function

function checkInStatus(status) {
    switch (status) {
        case 1:
            return { label: "Completed", color: "#008F2B" }
        case 2:
            return { label: "Pending", color: "#FFA200" }
        case 3:
            return { label: "Cancelled", color: "#FF0000" }
        case 4:
            return { label: "Problem", color: "#CD5C5C" }
        case 5:
            return { label: "Refund Check-in", color: "#FF69B4" }
        case 6:
            return { label: "Not Applicable", color: "#878787" }
        default:
            return { label: "Pending", color: "#FFA200" }
    }
};

function baggageStatus(status) {
    switch (status) {
        case 1:
            return { label: "Completed", color: "#008F2B" }
        case 2:
            return { label: "Pending", color: "#FFA200" }
        case 3:
            return { label: "Cancelled", color: "#FF0000" }
        case 4:
            return { label: "Problem", color: "#00A8FF" }
        case 5:
            return { label: "Refund_Bag", color: "#FF69B4" }
        case 6:
            return { label: "Not Applicable", color: "#878787" }
        default:
            return { label: "Pending", color: "#FFA200" }
    }
};

const extractDateMonthAndYear = (datestr) => {
    const date = new Date(datestr);
    const year = date.getUTCFullYear().toString().substr(-2);
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    const formattedDate = `${day}${month}${year}`;
    return formattedDate
}

const dateFormater = (str) => {
    const year = parseInt(str?.substr(0, 2));
    const month = parseInt(str?.substr(2, 2)) - 1;
    const day = parseInt(str?.substr(4, 2));
    const date = new Date(2000 + year, month, day);
    return date
}

//to send selected date in react-datepicker
const setAdvanceDate = (data) => {
    let currentDate = new Date(data)
    currentDate.setDate(currentDate.getDate() + 1);
    return currentDate;
}

//to disable previous date filter
const disablePrevDate = (date) => {
    const today = new Date()
    const nextDay = new Date(today);
    nextDay.setDate(today.getDate() - 1)
    return date > nextDay
};


//function to change currency symbol 
const checkCurrency = (name) => {
    switch (name) {
        case 'SFAU':
            return "AU$"
        case 'FMAU':
            return "AU$"
        case 'MTIAU':
            return "AU$"
        case 'NEO':
            return "₹"
        case 'TRV':
            return "₹"
        case 'VISA':
            return "₹"
        default:
            return "$"
    }
}

// Inquiry Status 
const FinalInquiryStatus = (id) => {
    switch (id) {
        case 1:
            return "Follow-up"
        case 2:
            return "Call-Back"
        case 3:
            return "Fake"
        case 4:
            return "Cancelled"
        case 5:
            return "Hold"
        case 6:
            return "Send-2-QC"
        case 7:
            return "Accept-QC"
        case 8:
            return "Reject-QC"
        case 9:
            return "Sale"
        case 10:
            return "Sale-Close"
        default:
            break;
    }
}

//visa status
const VisaStatus = (value) => {
    switch (value) {
        case 1:
            return "Valid_Stamped"
        case 2:
            return "Expired"
        case 3:
            return "Advance_Payroll"
        case 4:
            return "US_Citizen"
        case 5:
            return "Green_Card"
        case 6:
            return "Tourist_Visa"
        case 7:
            return "Canadian_Citizen"
        case 8:
            return "Studend_Visa"
        default:
            return;
    }
}

const cloneObject = (obj) => {
    return JSON.parse(JSON.stringify(obj));
}

//final status online inquiry reson
const finalInquiryReson = (value) => {
    switch (value) {
        case '1':
            return "Low Price Expected"
        case '2':
            return "Not Interested"
        case '3':
            return "Just Checking"
        case '4':
            return "No Response"
        case '5':
            return "Dates not confirm"
        case '6':
            return "Already booked"
        case '7':
            return "Sale Cancelled"
        case '8':
            return "Test Booking"
        default:
            return;
    }
}

const getOneDayAdvance = (date) => {
    const nextDate = new Date(date);
    nextDate.setDate(nextDate.getDate() + 1)
    return nextDate
}

const toastData = (msg) => {
    return <CToast autohide={true} visible={true} color="danger" className="text-white align-items-center">
        <div className="d-flex">
            <CToastBody><strong>{msg}</strong></CToastBody>
            <CToastClose className="me-2 m-auto" white />
        </div>
    </CToast>
}

const getISTTime = (utcTime) => {
    const istOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds
    const istTime = new Date(utcTime.getTime() + istOffset);
    return istTime;
};

const groupBy = (array, key) => {
    return Object.values(array.reduce((result, currentValue) => {
        (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
        return result;
    }, {}));
}

const getHotelOptionsByList = (optionsList) => {
    optionsList = optionsList.sort((a, b) => a.Id - b.Id);
    let data = [];
    let list = groupBy(optionsList, 'Option');
    list.map(options => {
        let hotels = [];
        options.map(hotel => {
            hotels.push({ Hotel: hotel.Hotel, Destination: hotel.Destination, Rooming: hotel.Rooming, NoOfNights: hotel.NoOfNights, MealPlan: hotel.MealPlan, Remarks: hotel.Remarks });
        })
        data.push({ Cost: options[0].Cost, CostType: options[0].CostType, Hotels: hotels, Currency: options[0].Currency });
    });
    return data;
}

const generateRandomFilename = () => {
    const timestamp = Date.now();
    const randomString = Math.random().toString(36).substring(2, 8); // Generate a random string of length 6
    return `${timestamp}_${randomString}.png`; // Append the timestamp and random string to form the filename
};

const getTimeDifference = (time) => {
    const currentTime = new Date();
    const timeDifference = new Date(time) - currentTime;
    const hours = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    return `${hours}Hr ${minutes}Min`;
}

const _utf8_encode = (e) => {
    e = e.replace(/\r\n/g, "\n");
    var t = "";
    for (var n = 0; n < e.length; n++) {
        var r = e.charCodeAt(n);
        if (r < 128) {
            t += String.fromCharCode(r);
        } else if (r > 127 && r < 2048) {
            t += String.fromCharCode((r >> 6) | 192);
            t += String.fromCharCode((r & 63) | 128);
        } else {
            t += String.fromCharCode((r >> 12) | 224);
            t += String.fromCharCode(((r >> 6) & 63) | 128);
            t += String.fromCharCode((r & 63) | 128);
        }
    }
    return t;
};

const encodeData = (e) => {
    const _keyStr = "abcdefghijklmnopqrstuvwxyz0123456789+/=ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var t = "";
    var n, r, i, s, o, u, a;
    var f = 0;
    e = _utf8_encode(e);
    while (f < e.length) {
        n = e.charCodeAt(f++);
        r = e.charCodeAt(f++);
        i = e.charCodeAt(f++);
        s = n >> 2;
        o = ((n & 3) << 4) | (r >> 4);
        u = ((r & 15) << 2) | (i >> 6);
        a = i & 63;
        if (isNaN(r)) {
            u = a = 64;
        } else if (isNaN(i)) {
            a = 64;
        }
        t = t + _keyStr.charAt(s) + _keyStr.charAt(o) + _keyStr.charAt(u) + _keyStr.charAt(a);
    }
    return t;
};

const formatSellKey = (key) => {
    return key.replaceAll("\\x7e", "~");
}

const getAdultYearOptions = () => {
    let options = [];
    let currentYear = new Date().getFullYear();
    let startPoint = currentYear - 110;
    let endPoint = currentYear - 11;
    for (let i = startPoint; i <= endPoint; i++) {
        options.push({
            value: i,
            label: i.toString(),
        });
    }
    return options;
};

const getFirstAdultYearOptions = () => {
    let options = [];
    let currentYear = new Date().getFullYear();
    let startPoint = currentYear - 110;
    let endPoint = currentYear - 18;
    for (let i = startPoint; i <= endPoint; i++) {
        options.push({
            value: i,
            label: i.toString(),
        });
    }
    return options;
};

const getChildYearOptions = () => {
    let options = [];
    let currentYear = new Date().getFullYear();
    let startPoint = currentYear - 12;
    let endPoint = currentYear - 2;
    for (let i = startPoint; i <= endPoint; i++) {
        options.push({
            value: i,
            label: i.toString(),
        });
    }
    return options;
};
const getInfantsYearOptions = () => {
    let options = [];
    let currentYear = new Date().getFullYear();
    let startPoint = currentYear - 2;
    let endPoint = currentYear;
    for (let i = startPoint; i <= endPoint; i++) {
        options.push({
            value: i,
            label: i.toString(),
        });
    }
    return options;
};

const checkLeapYear = (year) => {
    return new Date(year, 1, 29).getDate() === 29;
}

const isValidDayOfMonth = (value, monthValue, yearValue) => {
    value = parseInt(value);
    monthValue = parseInt(monthValue);

    if (
        (monthValue == 4 ||
            monthValue == 6 ||
            monthValue == 9 ||
            monthValue == 11) &&
        value > 30
    ) {
        return false;
    } else if (
        !!yearValue &&
        !checkLeapYear(yearValue.toString()) &&
        value > 28 &&
        monthValue == 2
    ) {
        return false;
    } else if (
        !!yearValue &&
        checkLeapYear(yearValue.toString()) &&
        value > 29 &&
        monthValue == 2
    ) {
        return false;
    }

    return true;
};

const getAge = (dateString, dateToCompare) => {
    var today = new Date(dateToCompare);
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
};

const numberFormat = (value) =>
    new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(value);

const getMaxDatePicker = () => {
    let dt = new Date();
    dt = new Date(dt.setMonth(dt.getMonth() + 11));
    return new Date(dt.setDate(dt.getDate() + 15));
};

const checkMaxDateRange = (maxDate, fromdate, diffDays) => {
    let max = moment(maxDate);
    let from = moment(fromdate);
    let diff = max.diff(from, "days");
    return diff < diffDays;
};

const cloneData = (data) => {
    return JSON.parse(JSON.stringify(data));
};

const isJsonString = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

const isLessThan7DaysFromNow = (travelDate, bookingDate = new Date()) => {
    const currentDate = new Date(bookingDate);
    const targetDate = new Date(currentDate);
    targetDate.setDate(currentDate.getDate() + 7); // Add 7 days to the current date
    const selectedDate = new Date(travelDate);
    if (selectedDate < new Date()) {
        return false;
    }
    return selectedDate < targetDate; // Compare the given date with the target date
}

const getSpecialFareType = (type) => {
    if (type == 'J')
        return specialFares.Flexi;

    else if (type == 'O')
        return specialFares.Super6E

    else
        return specialFares.Saver;
}

const downloadPdfFromByteArrayString = (byteArrayString, fileName) => {
    // Convert the base64-encoded string to a Uint8Array
    var byteCharacters = atob(byteArrayString);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);

    // Convert the Uint8Array to a Blob
    var blob = new Blob([byteArray], { type: "application/pdf" });

    // Create a temporary URL for the Blob
    var url = URL.createObjectURL(blob);

    // Create a link element
    var link = document.createElement("a");

    // Set the href attribute to the temporary URL
    link.href = url;

    // Set the download attribute to specify the file name
    link.download = fileName;

    // Append the link to the document
    document.body.appendChild(link);

    // Trigger a click event on the link to start the download
    link.click();

    // Remove the link from the document
    document.body.removeChild(link);

    // Revoke the temporary URL to free up resources
    URL.revokeObjectURL(url);
};

// Downloads a file that lives at a direct URL (e.g. a document returned by the API).
// Fetches it as a blob so the real file name is kept even for cross-origin storage;
// if the host blocks the request (no CORS), it falls back to opening the link instead.
const downloadFileFromUrl = async (url, fileName) => {
    if (!url) return;
    try {
        const res = await fetch(url);
        if (!res.ok) throw new Error('Failed to fetch file');
        const blob = await res.blob();
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = fileName || 'document';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(objectUrl);
    }
    catch {
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noreferrer';
        if (fileName) link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};

export {
    userRole,
    getFormattedDateTime,
    getFormattedDate2,
    getDiffFromMinutes,
    getFormattedTime,
    getFormattedDate3,
    getFormattedDate4,
    getDisplayClass,
    getToken,
    getFormattedDateTime1,
    getFormatedDateOfBirth,
    getFormattedContactNo,
    maskCardNumber,
    getDayDate,
    getUtcTime,
    onlyDateFormate,
    creditCardFormat,
    getFormattedDate5,
    getFormattedDate6,
    getFormattedDate7,
    convertSecondsToHMS,
    getTime,
    getTime2,
    getTime3,
    capitalizeFirstLetter,
    getCurrentPaymentStatus,
    checkInStatus,
    baggageStatus,
    extractDateMonthAndYear,
    dateFormater,
    setAdvanceDate,
    countTotalDuration,
    disablePrevDate,
    checkCurrency,
    dateFormateForDeepLinkFM,
    FinalInquiryStatus,
    VisaStatus,
    finalInquiryReson,
    getFormattedDateTime2,
    getFormattedDateTime3,
    getOneDayAdvance,
    cloneObject,
    toastData,
    getISTTime,
    getHotelOptionsByList,
    generateRandomFilename,
    getTimeDifference,
    encodeData,
    formatSellKey,
    getAdultYearOptions,
    getFirstAdultYearOptions,
    getChildYearOptions,
    getInfantsYearOptions,
    isValidDayOfMonth,
    getAge,
    numberFormat,
    getMaxDatePicker,
    checkMaxDateRange,
    cloneData,
    isJsonString,
    isLessThan7DaysFromNow,
    getSpecialFareType,
    downloadPdfFromByteArrayString,
    downloadFileFromUrl,
    getFormattedDate12,
    toLocalISOString
};